<template>
	<div id="header">
		<!--
		List<String> listWarns = null;
		int[] types = {Comment.NOTE_CAT_ACTIVITY, Comment.NOTE_CAT_ALL};
		List<Comment> warnings = CommentImpl.getComments(types,mf.getCustomer(), mf.getPerson(), mf.getBranch());
		boolean collectingFeedback = false;%>
		<%@ include file="force_info.jspf" %-->
		<div id="dispHeight"></div>
		<table class="headerTableForm">
			<tbody class="mainHeader">
			<tr>
				<td class="firstColumn"></td>
				<td class="fieldLabelColumn">{{env.msg("mailform.to")}}:</td>
				<td class="sugColumn">
					<autocomplete-input rest-api="./api/mails/suggest" v-model="recipients" 
						styleClass='reffieldMod width100p' separator=',' :size="32" :tabindex="10"
						name="email" value="email" :suggest-empty="true" />
				</td>
				<td class="fieldLabelColumn">{{env.msg("mailform.from")}}:</td>
				<td class="refColumn" colspan="2">
					<select v-model="senderAccount" :tabindex="20" >
						<option v-for="account in accounts" :key="account.id" :value="account.id">{{ account.title }}</option>
					</select>
				</td>
			</tr>
			<tr>
				<td class="firstColumn"></td>
				<td class="fieldLabelColumn">{{env.msg("mailform.cc")}}:</td>
				<td class="sugColumn">
					<autocomplete-input rest-api="./api/mails/suggest" v-model="recipientsCc"
						styleClass='reffieldMod width100p' separator=',' :size="32" :tabindex="30"
						name="email" value="email" :suggest-empty="true" />
				</td>

				<td class="fieldLabelColumn">{{env.msg("contact.customer")}}:</td>
				<td colspan="2">
					<autocomplete-input rest-api="./api/customers/suggest" v-model="customer" :size="32" :tabindex="40" 
						name="id" value="name" class='suggfield width100p'/>
				</td>
			</tr>

			<tr>
				<td class="firstColumn"></td>
				<td class="fieldLabelColumn">{{env.msg("mailform.bcc")}}:</td>
				<td class="sugColumn">
					<autocomplete-input rest-api="./api/mails/suggest" v-model="recipientsBcc" styleClass='reffieldMod width100p'
							separator=',' :size="32" :tabindex="50" name="email" value="email" :suggest-empty="true"/>
				</td>
				<td class="fieldLabelColumn">{{env.msg("contact.opportunity")}}:</td>
				<td class="refColumn" colspan="2">
					<autocomplete-input rest-api="./api/opportunities/suggest" v-model="opportunity" :size="32" :tabindex="60" 
						name="id" value="name"  :suggest-empty="true" class='suggfield width100p'/>
				</td>
			</tr>

			<tr>
				<td class="firstColumn"></td>
				<td class="fieldLabelColumn" style="font-weight:bold">{{env.msg("mailform.subject")}}:</td>
				<td class="sugColumn">
					<input type="text" v-model="subject" maxlength="255" tabindex="70" styleClass="width100p" style="font-weight:500;min-width:200px" @keyup="updateTitle('form.composeMail')"/></td>
				<td class="fieldLabelColumn">{{env.msg("contact.busCase")}}:</td>
				<td class="refColumn" colspan="2">
					<autocomplete-input rest-api="./api/buscases/suggest" v-model="busCase" :size="32" :tabindex="60"
						 name="id" value="name"  :suggest-empty="true" class='suggfield width100p'/>
				</td>
			</tr>
			</tbody>

			<tbody>
			<tr>
				<td colspan="6" style="border-bottom:1px solid var(--form-border-color)">
					<div class="mailSavingSplitter">
						<span @click="showAdvanced=!showAdvanced;doResize;" class="vueLink">
							<sym-icon name="plus-square-14"/> {{env.msg("mail.advanced")}}</span>
						<span class="mailSaving" v-show="mailSaving">{{env.msg("mail.saving")}}</span>
					</div>
				</td>
			</tr>
			</tbody>
			<tbody class="show-hide-box" v-show="showAdvanced">
			<tr>
				<td class="flabel" colspan="2">{{env.msg("mail.priority")}}:</td>
				<td>
					<select v-model="priority" :tabindex="150" >
						<option v-for="priority in priorities" :key="priority.id" :value="priority.id">{{ priority.title }}</option>
					</select>
				</td>
				<td v-if="mod.problem" class="flabel">{{env.msg("title.problem")}}:</td>
				<td v-if="mod.problem" colspan="2">
					<autocomplete-input rest-api="./api/problems/suggest" v-model="problem" :size="32" :tabindex="160"
						 name="id" value="name"  :suggest-empty="true" suggEmpty='true' class='suggfield width100p'/>
				</td>
				
			</tr>
			<tr>
				<td class="flabel" colspan="2">{{env.msg("mail.sendAfter")}}:</td>
				<td><datepicker styleId="sendAfter" v-model='sendAfter' tabindex="170"/></td>
				
				<td v-if="mod.campaign" class="flabel">{{env.msg("form.editCampaign")}}:</td>
				<td v-if="mod.campaign" colspan="2">
					<autocomplete-input rest-api="./api/campaigns/suggest" v-model="campaign" :size="32" :tabindex="160"
						 name="id" value="name"  :suggest-empty="true" suggEmpty='true' class='suggfield width100p'/>
				</td>
			</tr>
			<tr>
				<td class="flabel" colspan="2">{{env.msg("mail.visibleTo")}}:</td>
				<td colspan="2"><users v-model='visibilities' styleId='visibilities' tabindex="200" groups="true" multi="true" placeholder="mail.nobody"/></td>
				<td colspan="2"><label><input type="checkbox" v-model='useAsTemplate' tabindex="210"/> {{env.msg("mailform.useAsTemplate")}}</label></td>

			</tr>
			<tr>

				<td colspan="2" style="padding-bottom: 8px;"></td>
				<td colspan="2" style="padding-bottom: 8px;">
					<label><input type="checkbox" v-model='refreshVisibility' tabindex="220"/> {{env.msg("mail.refreshVisibility")}}</label>
				</td>
				<td colspan="2" style="padding-bottom: 8px;">
					<label><input type="checkbox" v-model='receipt' tabindex="230"/> {{env.msg("mail.receipt")}}</label></td>
			</tr>
			<tr class="controls">
				<td style="padding: 8px 2px; border-bottom:1px solid var(--form-border-color)" colspan="3">
					<label v-if="deleteConcept">
						<input type="checkbox" v-model='deleteConcept' tabindex="250"/> {{env.msg("mailform.deleteAfterSend")}}
					</label>
				</td>
				<td style="text-align: right; padding: 8px; border-bottom:1px solid var(--form-border-color)" colspan="3">
					<button styleClass="button" @click="disableAutoSave();saveMail();">{{env.msg("butt.save")}}</button>
				</td>
			</tr>
			</tbody>
		</table>

	</div>


	<div id="content" style="position: relative">
		<html-area-part v-model="body" width="100%" />
	</div>
	
	<div id="footer">
		<div id="attachments">
			<attachments rest-api="api/attachments" :mail-ident="mailIdent" ref="items" bundle-delete="title.deleteAttachment"></attachments>
		</div>
		<div class="footer-controls">
			<div id="fileZone" class="mail-attach-zone">
				<file-zone rest-api="api/attachments" :rest-params="'mailIdent='+mailIdent"
					zone-class="mailZone" zone-style="min-height: 70px;" :preview="false"
					bundle-drag="mail.moveAttachmentsHere" @uploaded="uploaded"></file-zone>
			</div>
			<div class="template-send">
				<span v-if="!pureHtmlBody">
					<!-- if (plu.hasSendMailButtons()) { %><%= plu.getSendMailButtons() %><% } -->
					<button type="submit" class="send-button" @click="disableAutoSave();sendMail();">
						<span class="send-icon"><sym-icon name="send"/></span>
						<span class="send-label">{{env.msg("butt.send")}}</span>
					</button>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {reactive, ref, computed, watch, onMounted} from 'vue';
	import {injectEnv} from "@fd/Environment";
	import {useRouter,useRoute} from "vue-router";
	
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import AutocompleteInput from '@/vue/form/AutocompleteInput.vue';
	import Attachments from '@/vue/attachment/Attachments.vue';
	import FileZone from '@/vue/file/FileZone.vue';
	import HtmlAreaPart from '@/fd/editors/html/HtmlAreaPart.vue';
	
	import type { MailMessage } from "@t/mail/MailMessage";
	
	/*const props = defineProps({
		mailIdent: String,
		showAdvanced: Boolean,
		
		conceptId: Number,
		restApi: String,
		params: String,
		suggestEmpty: Boolean,
		size: Number,
	});*/
	
	const env = injectEnv();
	const router = useRouter();
	const route = useRoute();
	
	const showAdvanced = ref<boolean>(false);
	const mailSaving = ref<boolean>(false);
	const mod = ref({problem:false});
	const body = ref<string>("");
	
	const mailMessage = ref<MailMessage>({mailIdent: ''});
	
	function doResize() {
		console.log("resize detected...TODO");
	}
	
	function checkOpenedMails() {
		console.log("chekc opened mails");
		let endpoint = "api/mailformmap/checkopenedmails?mailIdent="+mailMessage.value.mailIdent;
		env.net.fetch(endpoint)
			.then((result) => result.json())
			.then((data) => console.log("checkopenedmails:"+data.ok));
	}

	function loadData() {
		console.log("loaging data");
		let endpoint = "api/mailformmap/init";
		if (route.query.id) {
			endpoint = endpoint+"?id"+route.query.id;
		}
		return env.net.fetch(endpoint)
				.then((result) => result.json())
				.then(receivedData);
	}
	
	function receivedData(data:MailMessage):void {
		mailMessage.value = data;
		console.log("Initialized mailIdent:"+mailMessage.value.mailIdent);
	}

	console.log("initialized:"+JSON.stringify(route.query));
	onMounted(() => {
		loadData();
		setInterval(checkOpenedMails,300000);
	});

</script>